import React, { Fragment, useState, useEffect } from 'react';
import Breadcrumb from '../common/breadcrumb';
import Tablereact from '../common/tabulator/tablereact';
import AgregarProducto from './agregarProductos';
import ActualizarProducto from './actualizarProducto';
import Loader from '../common/loaderapp';
import Button from 'react-bootstrap-button-loader';
import { Modal, ModalHeader, ModalBody, ModalFooter, Dropdown, DropdownItem, DropdownToggle, DropdownMenu } from "reactstrap";
import Dropzone from "react-dropzone";
import notie from 'notie';
import '../../assets/css/notie.css';

const Productos = () => {

    const [pag_agregar, setPag_agregar] = useState(false);
    const [pag_actualizar, setPag_actualizar] = useState(0);
    const [load, setLoad] = useState(false);
    const [datos, setDatos] = useState([]);
    const [look, setLook] = useState(false);
    const [modalUpload, setModalUpload] = useState(false);
    const [archivo, setArchivo] = useState(null);
    const [archivoProcesado, setArchivoProcesado] = useState(null);
    const [modalUploadSust, setModalUploadSust] = useState(false);
    const [archivoSust, setArchivoSust] = useState(null);
    const [archivoProcesadoSust, setArchivoProcesadoSust] = useState(null);
    const [refreshKey, setRefreshKey] = useState(0);
    const [lookSust, setLookSust] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleDropdown = () => setDropdownOpen(prev => !prev);

    const [dropdownProductos, setDropdownProductos] = useState(false);
    const [dropdownSustitutos, setDropdownSustitutos] = useState(false);


    const toggleUpload = () => {
        setModalUpload(prev => {
            const next = !prev;
            if (prev) {
                setArchivo(null);
                setArchivoProcesado(null);
            }
            return next;
        });
    };

    const toggleUploadSust = () => {
        setModalUploadSust(prev => {
            const next = !prev;
            if (prev) {
                setArchivoSust(null);
                setArchivoProcesadoSust(null);
            }
            return next;
        });
    };

    useEffect(() => {
        fetch('/p_productos', { headers: { 'Content-Type': 'application/json' } })
            .then(res => res.json())
            .then(res => {
                setDatos(res)
                setLoad(true)
            })
            .catch(err => console.log('Error:', err))
    }, [pag_agregar, pag_actualizar, refreshKey]);

    const getExcel = async () => {
        setLook(true);
        fetch('/p_excel_admin', {
            headers: { 'Content-Type': 'application/json' }
        })
            .then(res => res.blob())
            .then(blob => {
                setLook(false);
                var file = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = file;
                a.download = "LOSPRIMOS.xlsx";
                document.body.appendChild(a);
                a.click();
                a.remove();
            })
            .catch(err => {
                setLook(false);
            })
    }

    const getExcelSustitutos = async () => {
        setLookSust(true);
        fetch('/p_excel_sustitutos_admin', {
            headers: { 'Content-Type': 'application/json' }
        })
            .then(res => res.blob())
            .then(blob => {
                setLookSust(false);
                var file = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = file;
                a.download = "LOSPRIMOS_Sustitutos.xlsx";
                document.body.appendChild(a);
                a.click();
                a.remove();
            })
            .catch(err => {
                setLookSust(false);
                notie.alert({ type: 'error', text: 'Error al descargar el archivo de sustitutos', time: 3 });
            })
    }

    const procesarArchivo = (file) => {
        if (!file) {
            setArchivoProcesado(null);
            return;
        }
        const reader = new FileReader();
        reader.onloadend = () => {
            setArchivoProcesado({ name: file.name, base: reader.result });
        };
        reader.onerror = () => setArchivoProcesado(null);
        reader.readAsDataURL(file);
    };

    const procesarArchivoSust = (file) => {
        if (!file) {
            setArchivoProcesadoSust(null);
            return;
        }
        const reader = new FileReader();
        reader.onloadend = () => {
            setArchivoProcesadoSust({ name: file.name, base: reader.result });
        };
        reader.onerror = () => setArchivoProcesadoSust(null);
        reader.readAsDataURL(file);
    };

    const handleSubir = () => {
        if (!archivoProcesado) return;
        setLook(true);
        fetch("/p_excel", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ archivo_adjunto: [archivoProcesado] })
        })
            .then(res => res.json())
            .then(() => {
                setLook(false);
                notie.alert({ type: 'success', text: 'Archivo subido correctamente', time: 2 });
                toggleUpload();
                setRefreshKey(prev => prev + 1);
            })
            .catch(err => {
                setLook(false);
                notie.alert({ type: 'error', text: 'Error al subir el archivo', time: 3 });
                console.log("Error: ", err);
            });
    };

    const handleSubirSust = () => {
        if (!archivoProcesadoSust) return;
        setLookSust(true);
        fetch("/p_excel_sustitutos", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ archivo_adjunto: [archivoProcesadoSust] })
        })
            .then(res => res.json())
            .then(payload => {
                setLookSust(false);
                if (payload?.status === 'ERROR') {
                    notie.alert({ type: 'error', text: payload?.resultado || 'Error al procesar el archivo', time: 3 });
                    return;
                }
                const totalArchivo = payload?.total_archivo ?? 0;
                const totalActualizados = payload?.total_actualizados ?? 0;
                const totalNoEncontrados = payload?.total_no_encontrados ?? 0;
                notie.alert({
                    type: 'success',
                    text: `Sustitutos actualizados. Filas: ${totalArchivo}, actualizados: ${totalActualizados}, no encontrados: ${totalNoEncontrados}`,
                    time: 3
                });
                toggleUploadSust();
                setRefreshKey(prev => prev + 1);
            })
            .catch(err => {
                setLookSust(false);
                notie.alert({ type: 'error', text: 'Error al subir el archivo de sustitutos', time: 3 });
                console.log("Error: ", err);
            });
    };

    const cabecera = [
        { Header: <b>SKU</b>, accessor: 'sku', style: { textAlign: 'center'}, width:'80', show:true },
        { Header: <b>Nombre</b>, accessor: 'name', style: { textAlign: 'center'}, width:'400', editable:true , show:true},
        // { Header: <b>Descripción</b>, accessor: 'short_description', style: { textAlign: 'center'}, width:'250', editable:true , show:true},
        { Header: <b>Marca</b>, accessor: 'marca', style: { textAlign: 'center'}, width:'auto', editable:true , show:true},
        { Header: <b>Unidad</b>, accessor: 'unidad', style: { textAlign: 'center'}, width:'110', editable:true , show:true},
        { Header: <b>Uso</b>, accessor: 'uso', style: { textAlign: 'center'}, width:'auto', editable:true , show:true},
        // { Header: <b>Estatus</b>, accessor: 'ESTATUS', style: { textAlign: 'center'}, width:'auto', editable:true , show:true}
    ];

    const agregar = () => setPag_agregar(true)
    const detalle_dato = (dato) => { setPag_actualizar(dato.sku) }

    return (
        <Fragment>
            <Breadcrumb parent="Inicio" title="Productos" />

            {load ? (

                (!pag_agregar && !pag_actualizar) ? (

                    <div className="container-fluid">
                        <div className="col-sm-12">
                            <div className="card">

                                <div className="d-flex flex-row-reverse" style={{ paddingTop: '10px', paddingRight: '10px' }}>

                                    <Button className="btn btn-primary mr-3" onClick={agregar}>
                                        Agregar producto <i class="icofont-ui-add" style={{ paddingLeft: 5 }}></i>
                                    </Button>

                                    <Button className="btn btn-success mr-3" onClick={toggleUpload}>
                                        Productos
                                    </Button>

                                    <Button className="btn btn-primary mr-3" onClick={toggleUploadSust}>
                                        Sustitutos
                                    </Button>

                                </div>

                                <div className="card-body datatable-react">
                                    <Tablereact
                                        myData={datos}
                                        cabecera={cabecera}
                                        pageSize={20}
                                        paginacion={true}
                                        buscador='Buscar Producto'
                                        detalle={detalle_dato}
                                        /* boton={{ text: 'Agregar Producto', function: agregar }} */
                                    />
                                </div>

                            </div>
                        </div>

                        <Modal isOpen={modalUpload} toggle={toggleUpload} size="lg">
                            <ModalHeader toggle={toggleUpload}>Cargar Excel</ModalHeader>

                            <ModalBody>
                                <Dropzone
                                    accept={{
                                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
                                        "application/vnd.ms-excel": [".xls"]
                                    }}
                                    multiple={false}
                                    onDrop={(accepted) => {
                                        const file = accepted[0] || null;
                                        setArchivo(file);
                                        procesarArchivo(file);
                                    }}
                                >
                                    {({ getRootProps, getInputProps }) => (
                                        <div
                                            {...getRootProps()}
                                            style={{
                                                border: "2px dashed #3b1d82",
                                                background: "#dcd2f1",
                                                padding: "60px",
                                                textAlign: "center",
                                                cursor: "pointer",
                                                borderRadius: "10px"
                                            }}
                                        >
                                            <input {...getInputProps()} />
                                            {archivo ?
                                                <h5><b>{archivo.name}</b></h5>
                                                :
                                                <h5 style={{ color: "#3b1d82", fontWeight: "bold" }}>
                                                    Arrastre o toque para insertar un archivo
                                                </h5>
                                            }
                                        </div>
                                    )}
                                </Dropzone>
                            </ModalBody>

                            <ModalFooter className="d-flex justify-content-between">
                                <Button className="btn btn-success mr-3" onClick={() => { getExcel() }} loading={look}>
                                    Descargar Excel <i className="icofont-download" style={{ paddingLeft: 5 }}></i>
                                </Button>
                                
                                <div className="content">
                                    <Button className="btn btn-secondary mr-3" onClick={toggleUpload}>
                                        Cancelar
                                    </Button>

                                    <Button
                                        className="btn btn-primary"
                                        disabled={!archivoProcesado || look}
                                        onClick={handleSubir}
                                        loading={look}
                                    >
                                        Subir
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>

                        <Modal isOpen={modalUploadSust} toggle={toggleUploadSust} size="lg">
                            <ModalHeader toggle={toggleUploadSust}>Cargar Excel de Sustitutos</ModalHeader>

                            <ModalBody>
                                <p className="text-muted">
                                    Formato requerido: columna SKU y columna Sustitutos (SKUs separados por comas).
                                </p>
                                <Dropzone
                                    accept={{
                                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
                                        "application/vnd.ms-excel": [".xls"]
                                    }}
                                    multiple={false}
                                    onDrop={(accepted) => {
                                        const file = accepted[0] || null;
                                        setArchivoSust(file);
                                        procesarArchivoSust(file);
                                    }}
                                >
                                    {({ getRootProps, getInputProps }) => (
                                        <div
                                            {...getRootProps()}
                                            style={{
                                                border: "2px dashed #3b1d82",
                                                background: "#dcd2f1",
                                                padding: "60px",
                                                textAlign: "center",
                                                cursor: "pointer",
                                                borderRadius: "10px"
                                            }}
                                        >
                                            <input {...getInputProps()} />
                                            {archivoSust ?
                                                <h5><b>{archivoSust.name}</b></h5>
                                                :
                                                <h5 style={{ color: "#3b1d82", fontWeight: "bold" }}>
                                                    Arrastre o toque para insertar un archivo
                                                </h5>
                                            }
                                        </div>
                                    )}
                                </Dropzone>
                            </ModalBody>

                            <ModalFooter className="d-flex justify-content-between">

                                <Button className="btn btn-success mr-3" onClick={() => { getExcelSustitutos() }} loading={lookSust}>
                                    Descargar Excel <i className="icofont-download" style={{ paddingLeft: 5 }}></i>
                                </Button>
                                
                                <div className="content">
                                    <Button className="btn btn-secondary mr-3" onClick={toggleUploadSust}>
                                        Cancelar
                                    </Button>

                                    <Button
                                        className="btn btn-primary"
                                        disabled={!archivoProcesadoSust || lookSust}
                                        onClick={handleSubirSust}
                                        loading={lookSust}
                                    >
                                        Subir
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>

                    </div>

                ) : (!pag_actualizar ?
                    <AgregarProducto setPag_agregar={setPag_agregar} /> :
                    <ActualizarProducto pag_actualizar={pag_actualizar} setPag_actualizar={setPag_actualizar} />
                )

            ) : (
                <Loader />
            )}
        </Fragment>
    );
};

export default Productos;
